module.exports = __webpack_public_path__ + "static/favicon-f668d153029365ad1e4ba1c5a09e5a64.png";